export default __webpack_public_path__ + "static/media/ISCO CLASS-1_SYLLABUS_2025-26.2ae1d5ef.pdf";